import { createSlice } from "@reduxjs/toolkit";
import { spaceDelete } from "./spaceAsyncThunk";

const spaceDeleteSlice = createSlice({
  name: "space",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [spaceDelete.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [spaceDelete.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [spaceDelete.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default spaceDeleteSlice.reducer;
